import { FC } from 'react';

import { resetPassword } from 'aws-amplify/auth';

import { IStepFormProps as Props } from 'interfaces/auth';
import { IEnterCodeStepValues } from 'interfaces/confirmationCode';

import { useAuthModalsContext } from 'components/AuthModals';
import { ConfirmationCodeForm } from 'components/ConfirmationCodeForm/ConfirmationCodeForm';
import { useResetPasswordContext } from 'components/ResetPassword/ResetPasswordContextProvider/ResetPasswordContextProvider';

export const EnterCodeStep: FC<Props> = ({ onClose }) => {
  const { prevStep, nextStep, confirmationCodeError, setCodeError } = useResetPasswordContext();
  const { resetFormData, setResetFormData } = useAuthModalsContext();

  const onSubmit = ({ code }: IEnterCodeStepValues): void => {
    setResetFormData((prev) => ({ ...prev, code }));
    nextStep();
  };

  const handleBackClick = (): void => {
    setCodeError('');
    prevStep();
  };

  return (
    <ConfirmationCodeForm
      isPending={false}
      emailValue={resetFormData.email}
      codeValue={resetFormData.code}
      codeError={confirmationCodeError}
      backClickHandler={handleBackClick}
      closeClickHandler={onClose}
      resendCodeHandler={resetPassword}
      onSubmit={onSubmit}
    />
  );
};
